import axios from 'axios'
import url from './base-url';
const api = axios.create({
    baseURL: url
})
function Headers(auth) {
    return {headers:{ 'x-access-token': auth,'Content-Type': 'application/json'}};
}
export const insertProduct = (payload,auth) => api.post('/product', payload,Headers(auth));
export const getAllProducts = (auth) => api.get('/products',Headers(auth));

const apis = {
    insertProduct,
    getAllProducts
}

export default apis